import { useNavigate } from "react-router";
import { Badge } from "@/components/ui/badge";

interface MasterVersionBadgeProps {
  masterId: string;
  masterVersionId: string;
  masterName: string;
  className?: string;
}

export function MasterVersionBadge({
  masterId,
  masterVersionId,
  masterName,
  className,
}: MasterVersionBadgeProps) {
  const navigate = useNavigate();

  if (!masterName) {
    return null;
  }

  const handleClick = () => {
    navigate(`/spec-lists/${masterId}/version/${masterVersionId}`);
  };

  return (
    <Badge
      variant="secondary"
      className={`cursor-pointer hover:bg-secondary/80 transition-colors ${className}`}
      onClick={handleClick}
    >
      {masterName}
    </Badge>
  );
}
